import { FolderTreeIcon } from 'components/Icons';

import { registerTaskOption } from '../options';

import { SampleProjectsModal } from './SampleProjectsModal';

export default registerTaskOption({
  Icon: FolderTreeIcon,

  getLabel: (t) => t('sample-projects'),

  modal: 'SAMPLE_PROJECTS',
  overlay: SampleProjectsModal,

  shortcutKey: 'V',

  useOption: ({ task, openModal }) => ({
    action: () => openModal('SAMPLE_PROJECTS'),
    isEnabled: !!task.canCreateSampleProject,
  }),
});
